module.exports = __webpack_public_path__ + "img/meeting.41bde46c.png";